<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    <ion-title>Zahlung</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="previewPayment()"
        [disabled]="!this.paymentForm.valid"
        [strong]="true"
        >Weiter</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="paymentForm"
    class="bg-iosbackground dark:bg-transparent pt-5"
  >
    <ion-list>
      <ion-item lines="full" button (click)="selectStudent()" [disabled]="payment() !== null" detail="true">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="person-outline"
            class="-mt-1 text-lg"
          ></ion-icon>
        </ion-note>
        <ion-label
          >{{
            paymentForm.value.student?.forename || "Fahrschüler auswählen"
          }}
          {{ paymentForm.value.student?.surname }}</ion-label
        >
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="calendar-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="Datum"
          formControlName="date"
          placeholder="Datum"
          type="date"
        ></ion-input>
      </ion-item>
      <ion-item lines="full">
        <!-- one input field with default set to 0 and max input as total_amount of invoiceForm -->
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="wallet-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-select
          class="text-right"
          formControlName="payment_method"
          value="cash"
          okText="Festlegen"
          cancelText="Abbrechen"
          aria-label="Zahlungsmethode"
        >
          <ion-select-option value="Bar">Bar</ion-select-option>
          <ion-select-option value="Bank">Bank</ion-select-option>
          <ion-select-option value="Twint">Twint</ion-select-option>
          <ion-select-option value="Kreditkarte">Kreditkarte</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="cash-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="CHF"
          formControlName="amount"
          placeholder="0.00"
          type="number"
        ></ion-input>
      </ion-item>
      @if (paymentForm.controls?.amount.touched && paymentForm.controls?.amount.errors?.max) {
        <ion-item lines="full" class="flex justify-center h-8 flex-col-reverse">
          <ion-note slot="start">
            <ion-icon
              color="primary"
              name=""
              class="text-lg"
            ></ion-icon>
          </ion-note>
          <ion-text class="text-xs text-red-700"
            >Die Zahlung darf den offenen Rechnungsbetrag nicht überschreiten.</ion-text
          >
        </ion-item>
      }
    </ion-list>
  </form>
  <div class="h-8"></div>
</ion-content>
